<template>
  <div class="margin-header">
    <TopBar :title="$vuetify.lang.t('$vuetify.VisitorCreate.pageName')" />
    <div class="box-round display-height">
      <div class="box-content box-content-custom px-6">
        <v-form lazy-validation ref="form" v-model="valid">
          <div class="row">
            <div class="col-4">
              <div class="position-relative">
                <div
                  v-if="profileBase64"
                  class="block-img elevation-3"
                  style="border-radius: 50%;overflow:hidden">
                  <img
                    class="img-fluid shadow img"/>
                </div>
                <v-img
                  v-else
                  class="img-fluid"
                  src="@/assets/images/icons/upload-user.png"/>

                <div class="edit-img" @click="clickUploadProfile()">
                  <v-icon small class="text-white">mdi mdi-pencil</v-icon>
                  <input type="file" @change="uploadProfile" ref="img-profile" accept="image/*" class="hide"/>
                </div>
              </div>
            </div>
            <div class="col-8">
              <div class="font-weight-bold line-liff-detail liff-line-font-size-18">
                  {{$vuetify.lang.t('$vuetify.VisitorCreate.profile.name')}}
              </div>
              <small class="text-base-grey2 font-roboto liff-line-font-size-12">
                  {{$vuetify.lang.t('$vuetify.VisitorCreate.profile.detail')}}
              </small>
            </div>
          </div>
          <div class="row pt-4">
            <div class="title-label col-12 line-liff-detail">
              {{$vuetify.lang.t('$vuetify.VisitorCreate.passportId.title')}} <span class="required-input"></span>
            </div>
            <div class="col-12">
              <v-text-field
                class="custom-input line-liff-detail"
                hide-details="auto"
                outlined
                required
                :rules="idnumRules"
                v-model="form.passportId"
                :placeholder="$vuetify.lang.t('$vuetify.VisitorCreate.passportId.placeholder')"
              ></v-text-field>
            </div>
          </div>
          <div class="row pt-3">
            <div class="title-label col-12 line-liff-detail">
                {{$vuetify.lang.t('$vuetify.VisitorCreate.name.title')}} <span class="required-input"></span>
            </div>
            <div class="col-12">
              <v-text-field
                class="custom-input"
                hide-details="auto"
                outlined
                :rules="nameRule"
                required
                v-model="form.name"
                :placeholder="$vuetify.lang.t('$vuetify.VisitorCreate.name.placeholder')"
              ></v-text-field>
            </div>
          </div>
          <div class="row pt-3">
            <div class="title-label col-12 line-liff-detail">
                {{$vuetify.lang.t('$vuetify.VisitorCreate.surname.title')}} <span class="required-input"></span>
            </div>
            <div class="col-12">
              <v-text-field
                :rules="surnameRule"
                class="custom-input"
                hide-details="auto"
                outlined
                v-model="form.surname"
                :placeholder="$vuetify.lang.t('$vuetify.VisitorCreate.surname.placeholder')"
              ></v-text-field>
            </div>
          </div>
          <div class="row pt-3">
            <v-radio-group
              v-model="form.gender"
              row
              class="gender col-12 line-liff-detail"
              :rules="inputRules">
              <template #label>
                  {{ $vuetify.lang.t('$vuetify.visitorForm.gender') }}<span class="require-star">* </span>
              </template>
              <div class="gender-radio">
                  <v-radio
                      class="radio-group font-weight-bold"
                      :label="this.$vuetify.lang.t('$vuetify.visitorForm.male')"
                      value="M">
                  </v-radio>
                  <v-radio
                      class="radio-group font-weight-bold"
                      :label="this.$vuetify.lang.t('$vuetify.visitorForm.female')"
                      value="F">
                  </v-radio>
              </div>
            </v-radio-group>
          </div>
          <div class="row pt-3">
              <div class="title-label col-12 line-liff-detail">
                  {{$vuetify.lang.t('$vuetify.VisitorCreate.visitAt.title')}} <span class="required-input"></span>
              </div>
              <div class="col-12 pb-0">
                  <v-select
                    :placeholder="$vuetify.lang.t('$vuetify.VisitorCreate.visitAt.placeholder')"
                    class="custom-ddl"
                    :items="options"
                    outlined
                    :rules="visitAtRule"
                    v-model="form.visitAt"
                  ></v-select>
              </div>
          </div>
          <div class="row pt-6">
            <div class="title-label col-12 line-liff-detail">
                {{$vuetify.lang.t('$vuetify.VisitorCreate.email.title')}}
            </div>
            <div class="col-12 pb-0">
                <v-text-field
                  class="custom-input"
                  hide-details="auto"
                  :rules="emailRules"
                  outlined
                  v-model="form.email"
                  :placeholder="$vuetify.lang.t('$vuetify.VisitorCreate.email.placeholder')"
                ></v-text-field>
              <input
                type="text"
                class="form-control"
              />
            </div>
          </div>
          <div class="row pt-1">
            <div class="title-label col-12">
                {{$vuetify.lang.t('$vuetify.VisitorCreate.phone.title')}} <span class="required-input"></span>
            </div>
            <div class="col-12">
                <v-text-field
                  type="text"
                  class="custom-input"
                  autocomplete="off"
                  outlined
                  v-mask = "'## ### ####'"
                  @input="onInputPhone()"
                  v-model="form.phone"
                  :prefix="`(${nationalTelCode})`"
                  :placeholder="$vuetify.lang.t('$vuetify.VisitorCreate.phone.placeholder')"
                ></v-text-field>
            </div>
          </div>
          <div class="row pt-3">
            <div class="title-label col-12 pt-0 line-liff-detail">
                {{$vuetify.lang.t('$vuetify.VisitorCreate.operator.title')}}
                <span class="required-input"></span>
            </div>
            <div class="col-12 pt-4 pb-1 position-relative">
              <v-text-field
                  @input="inputOperator()"
                  class="custom-input"
                  hide-details="auto"
                  outlined
                  :rules="operatorRule"
                  v-model="form.operator"
                  :placeholder="$vuetify.lang.t('$vuetify.VisitorCreate.operator.placeholder')"
                ></v-text-field>
                <div class="area-operator" v-if="isSearch && listOperator.length > 0">
                  <div class="elevation-4 rounded overflow-hidden line-liff-detail">
                    <div class="list-operator">
                        <div class="item-operator" v-for="(v,i) of listOperator" :key="i" @click="clickOperator(v.value, v.text)">
                          {{v.text}}
                        </div>
                    </div>
                    <div class="btn-close" @click="isSearch = false">
                        {{$vuetify.lang.t('$vuetify.VisitorCreate.operator.btnClose')}}
                    </div>
                  </div>
                </div>
            </div>
            <div class="col-12 text-sm py-0">
              <small class="font-roboto liff-line-font-size-12">{{$vuetify.lang.t('$vuetify.VisitorCreate.operator.detail')}}</small>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-12 mt-1 pb-0">
              <div class="btn-upload text-truncate" @click="clickUpload()">
                <div class="d-flex align-items-center">
                  <v-icon small>fas fa-file-upload</v-icon>
                  <span class="ml-2 line-liff-detail liff-line-font-size-18">{{$vuetify.lang.t('$vuetify.VisitorCreate.uploadIdCard.title')}}</span>
                </div>
              </div>
              <input
                type="file"
                accept="image/*"
                class="no-display hide"
                ref="file"
                @change="uploadIdCard($event)"/>
            </div>
            <div class="col-12 py-0 text-sm mt-1">
                <small class="font-roboto liff-line-font-size-12">
                  <span class="required-input"></span>
                  {{$vuetify.lang.t('$vuetify.VisitorCreate.uploadIdCard.placeholder')}}
                </small>
                <div v-if="idCardBase64" class="rounded position-relative mt-2  elevation-2" style="max-width: 200px;">
                    <div class="btn-remove elevation-5" @click="clickRemoveIdCard()">x</div>
                    <div class="overflow-hidden">
                      <img class="w-100" :src="idCardBase64" />
                    </div>
                </div>
            </div>
          </div>
          <div class="row pt-4">
            <div class="col-12 pb-1 text-black font-weight-bold line-liff-detail liff-line-font-size-18">
                {{$vuetify.lang.t('$vuetify.VisitorCreate.accessInfo')}}
            </div>
            <div class="col-12 pt-4 px-0">
                <div class="row" style="margin: -14px;font-size:19px !important; ">
                    <v-date-picker
                      v-model="form.dates"
                      :min="currentDate"
                      multiple
                      full-width
                      class="font-size-calendar"
                    ></v-date-picker>
                </div>
            </div>
          </div>
          <div
            class="row pb-1"
            v-if="form.dates.length > 0">
            <div class="col-12 pt-4">
                <div class="row">
                    <div class="col-6 pb-0">
                      <div class="title-label">
                          {{$vuetify.lang.t('$vuetify.VisitorCreate.startTime.title')}} <span class="required-input"></span>
                      </div>
                      <div class="mt-3">
                        <CustomTimePicker
                          v-model="form.startTime"/>
                      </div>
                    </div>
                    <div class="col-6 pb-0">
                      <div class="title-label">
                          {{$vuetify.lang.t('$vuetify.VisitorCreate.endTime.title')}} <span class="required-input"></span>
                      </div>
                      <div class="mt-3">
                        <CustomTimePicker
                          :disabledTimeFrom="form.startTime"
                          v-model="form.endTime"/>
                      </div>
                    </div>
                    <div class="col-12 pt-0 font-roboto" style="margin-top:-25px;">
                      <small>
                        <span class="required-input"></span>
                        {{$vuetify.lang.t('$vuetify.VisitorCreate.setupDetail')}}
                      </small>
                    </div>
                </div>
            </div>
          </div>
        </v-form>
      </div>
      <div class="box-footer box-buttom">
        <div class="row mt-5">
          <div class="col-6">
            <ButtonNoBackground
              @clickButton="clickCancel()"
              :title="$vuetify.lang.t('$vuetify.VisitorCreate.button.cancel')" />
          </div>
          <div class="col-6">
            <ButtonFullBackground
              :title="$vuetify.lang.t('$vuetify.VisitorCreate.button.submit')"
              @clickButton="clickSubmit()" />
          </div>
        </div>
      </div>
    </div>
    <ModalSuccess ref="modal-success" @clickOk="onClickConfirm(true)" />
    <ModalFail ref="modal-fail"  @clickOk="onClickConfirm(false)" />
  </div>
</template>
<script>
import { mask } from 'vue-the-mask'
import moment from 'moment'
import TopBar from '@/components/Liff/Components/header/TopBar.vue'
import ButtonNoBackground from '@/components/Liff/Components/button/ButtonNoBackground.vue'
import ButtonFullBackground from '@/components/Liff/Components/button/ButtonFullBackground.vue'
import CustomTimePicker from '@/components/Liff/Components/Input/CustomTimePicker.vue'
import ModalSuccess from '@/components/Liff/Modals/ModalSuccess.vue'
import ModalFail from '@/components/Liff/Modals/ModalFail.vue'
export default {
    name: 'VisitorCreate',
    directives: {
        mask
    },
    components: {
        TopBar,
        ButtonFullBackground,
        ButtonNoBackground,
        CustomTimePicker,
        ModalFail,
        ModalSuccess
    },
    data: function () {
        return {
            currentDate: null,
            listOperator: [],
            isSearch: false,
            isFirstClick: true,
            valid: true,
            lineUserId: null,
            lineLiffId: process.env.VUE_APP_LINE_LIFF_VISITOR_CREATE,
            delayTimer: null,
            fileName: null,
            profileBase64: null,
            idCardBase64: null,
            nationalTelCode: '+66',
            form: {
                passportId: null,
                name: null,
                surname: null,
                gender: null,
                visitAt: null,
                email: null,
                phoneStart: null,
                phone: null,
                operator: null,
                operatorId: null,
                dates: [],
                startTime: null,
                endTime: null
            },
            options: [],
            nameRule: [
                v => (!!v) || this.$vuetify.lang.t('$vuetify.VisitorCreate.name.require')
            ],
            operatorRule: [
                v => (!!v) || this.$vuetify.lang.t('$vuetify.VisitorCreate.operator.require')
            ],
            surnameRule: [
                v => (!!v) || this.$vuetify.lang.t('$vuetify.VisitorCreate.surname.require')
            ],
            visitAtRule: [
                v => (!!v) || this.$vuetify.lang.t('$vuetify.VisitorCreate.visitAt.require')
            ],
            startTimeRule: [
                v => (!!v) || this.$vuetify.lang.t('$vuetify.VisitorCreate.startTime.require')
            ],
            endTimeRule: [
                v => (!!v) || this.$vuetify.lang.t('$vuetify.VisitorCreate.endTime.require')
            ],
            emailRules: [
                vmail => {
                    if (!vmail) return true
                    else return ((vmail) && /.+@.+\..+/.test(vmail)) || this.$vuetify.lang.t('$vuetify.VisitorCreate.email.invalid')
                }
            ],
            phoneRules: [
                v => (v && v.length === 11) || this.$vuetify.lang.t('$vuetify.VisitorCreate.phone.invalid')
            ],
            idnumRules: [
                v => (!!v) || this.$vuetify.lang.t('$vuetify.VisitorCreate.idNumber.require')
            ],
            inputRules: [
                v => this.$validator.hasValue(v, this.$vuetify.lang.t('$vuetify.visitorForm.thisFieldIsRequired')),
                v => this.$validator.lengthNotExceed(v, 255, this.$vuetify.lang.t('$vuetify.visitorForm.thisFieldIsExceeded255Characters'))
            ]
        }
    },
    created: function () {
        this.currentDate = moment().format('YYYY-MM-DD') + ' 00:00:00'
    },
    mounted: function () {
        this.initialData()
    },
    methods: {
        initialData: async function () {
            this.$store.dispatch('setLoading', true)
            try {
                const res = await this.axios.get('bureau/options')
                this.options = res.data.data.map(o => {
                    return { ...o, value: `${o.value}` }
                })
                const lineUserId = await this.$liffUtil.getLineIdForLiff(this.lineLiffId)
                this.lineUserId = lineUserId
            } catch {
            }
            this.$store.dispatch('setLoading', false)
        },
        clickRemoveIdCard: function () {
            this.idCardBase64 = null
            this.fileName = null
        },
        onInputPhone: function () {
        },
        onClickConfirm: function (isCloseLine) {
            this.$refs.form.resetValidation()
            this.form = {
                passportId: null,
                name: null,
                surname: null,
                gender: null,
                visitAt: null,
                email: null,
                phoneStart: null,
                phone: null,
                operator: null,
                dates: [],
                startTime: null,
                endTime: null
            }
            if (isCloseLine) this.clickCancel()
        },
        clickCancel: function () {
            this.$liffUtil.closeWindow(this.lineLiffId)
        },
        clickSubmit: async function () {
            let isValid = true
            this.isFirstClick = false
            this.$refs.form.validate()
            // manual validate
            const validateField = ['name', 'surname', 'visitAt', 'operator', 'email', 'phone', 'startTime', 'endTime']
            for (const key of validateField) {
                if (Object.hasOwnProperty.call(this.form, key)) {
                    const value = this.form[key]
                    if (!value) isValid = false
                }
            }
            if (this.form.email && !(/.+@.+\..+/.test(this.form.email))) isValid = false
            if (this.form.phone && this.form.phone.length !== 11) isValid = false
            if (isValid) {
                this.$store.dispatch('setLoading', true)
                try {
                    const params = this.getParams()
                    const res = await this.axios.post('visitor/line/create', params)
                    if (res && res.data.status && res.data.status === 'ok') {
                        this.openModalSuccess(res.data.msg)
                    } else {
                        const title = this.$vuetify.lang.t('$vuetify.VisitorCreate.modalFail.titleFail')
                        const body = res.data.msg
                        this.openModalFail(title, body)
                    }
                } catch {
                }
                this.$store.dispatch('setLoading', false)
            }
        },
        cutCharacter: function () {
            this.form.phone = this.form.phone.replace(/[^0-9 ]/g, '')
        },
        onChangePhoneStart: function () {
            this.form.phone = this.form.phoneStart
        },
        inputOperator: async function () {
            clearTimeout(this.delayTimer)
            this.delayTimer = setTimeout(this.searchOperator, 1000)
        },
        clickOperator: async function (id, name) {
            this.isSearch = false
            this.listOperator = []
            this.form.operator = name
            this.form.operatorId = id
        },
        searchOperator: async function () {
            this.$store.dispatch('setLoading', true)
            try {
                const res = await this.axios.get('employee/options?search=' + this.form.operator)
                if (res && res.data.status && res.data.status === 'ok') {
                    if (res.data.data.length === 0) {
                        this.isSearch = true
                        this.listOperator = [{ name: 'text', id: 11111 }, { name: 'text2', id: 22222 }]
                    } else {
                        this.isSearch = true
                        this.listOperator = res.data.data
                    }
                }
            } catch {
                this.isSearch = false
            }
            this.$store.dispatch('setLoading', false)
        },
        clickUploadProfile: function () {
            this.$refs['img-profile'].click()
        },
        uploadProfile: async function (e) {
            if (e.target.files.length > 0) {
                const file = e.target.files[0]
                const sizeInKB = file.size / 1000
                if (sizeInKB < 25 || sizeInKB > 200) {
                    const title = this.$vuetify.lang.t('$vuetify.VisitorCreate.modalFail.title')
                    const body = this.$vuetify.lang.t('$vuetify.VisitorCreate.modalFail.bodyFile')
                    this.openModalFail(title, body)
                } else {
                    this.fileName = file.name
                    this.profileBase64 = await this.$imageUtil.getBase64(file)
                }
            }
        },
        changeGender: function (gender) {
            this.form.gender = gender
        },
        clickUpload: function () {
            this.$refs.file.click()
        },
        uploadIdCard: async function (e) {
            if (e.target.files.length > 0) {
                const file = e.target.files[0]
                const sizeInMB = file.size / (1000 * 1000)
                if (sizeInMB > 100) {
                    const title = this.$vuetify.lang.t('$vuetify.VisitorCreate.modalFail.title')
                    const body = this.$vuetify.lang.t('$vuetify.VisitorCreate.uploadIdCard.placeholder')
                    this.openModalFail(title, body)
                } else {
                    this.fileName = file.name
                    this.idCardBase64 = await this.$imageUtil.getBase64(file)
                }
                this.$refs.file.value = ''
            }
        },
        getParams: function () {
            const params = {
                lineId: this.lineUserId,
                profileImage: this.profileBase64,
                citizenId: this.form.passportId,
                firstName: this.form.name,
                lastName: this.form.surname,
                gender: this.form.gender,
                bureauId: this.form.visitAt,
                email: this.form.email,
                phone: `${this.nationalTelCode} ${this.form.phone}`, // String(i.e. +66 88 999 1234)
                operatorId: this.form.operatorId,
                cardImage: this.idCardBase64,
                plan: {
                    dates: this.form.dates,
                    startTime: `${this.form.startTime}:00`,
                    endTime: `${this.form.endTime}:00`
                }
            }
            return params
        },
        openModalSuccess: function (body) {
            const title = this.$vuetify.lang.t('$vuetify.VisitorCreate.modalSuccess.title')
            const btnOk = this.$vuetify.lang.t('$vuetify.VisitorCreate.modalSuccess.btnOk')
            const params = {
                title: title,
                btnOk: btnOk,
                body: body
            }
            this.$refs['modal-success'].show(params)
        },
        openModalFail: function (title, text) {
            const btnOk = this.$vuetify.lang.t('$vuetify.VisitorCreate.modalFail.btnOk')
            const params = {
                title: title,
                btnOk: btnOk,
                body: text
            }
            this.$refs['modal-fail'].show(params)
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/styles/color.scss";
.btn-remove {
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $base-orange;
  color: #fff;
  border-radius: 100%;
  position: absolute;
  right: -5px;
  top: -5px;
}
.block-img {
  width: 100%;
  padding-top: 100%;
  position: relative;
  .img {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
  }
}

.btn-close {
  color: #fff;
  padding: 5px;
  text-align: center;
  background: $base-orange;
}
.area-operator {
  z-index: 10;
  position: absolute;
  left: 0;
  top: 60px;
  width: 100%;
  background: #fff;
  padding: 10px;
  border-radius: 10px;
  .list-operator {
    max-height: 140px;
    overflow-y: auto;
    .item-operator{
      padding: 5px 10px;
      &:not(:last-child) {
        border-bottom: 1px solid $base-grey;
      }
    }
  }
}

.w-100 {
  width: 100%;
}
.title-label {
  font-size: 14px;
  margin-bottom: -10px;
}
div > .text-white {
  color: #fff;
}
.vs__selected-options {
  display: flex;
}

.btn-upload {
  text-align: center;
  font-weight: bold;
  color: $base-orange;
  position: relative;
  border: 2px solid $base-orange;
  padding: 5px 10px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    color: $base-orange;
  }
}

.edit-img {
  width: 30px;
  height: 30px;
  position: absolute;
  right: 0;
  bottom: 0;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: $base-orange;
}
  ::v-deep .th-locale .v-text-field__slot{
    font-family: Sarabun !important;
  }
  ::v-deep .en-locale .v-text-field__slot{
    font-family: LexendDeca !important;
  }
.box-content-custom {
  padding-bottom: 100px;
}
.gender-radio {
    display: flex;
    width: 100%;
}
::v-deep .gender {
    margin-top: 15px;

    .v-input--radio-group__input {
        flex-flow: column;
        align-items: flex-start;

        legend {
            width: 100%;
            text-align: left;
        }
    }

    .gender-radio {
        display: flex;
    }

    @media only screen and (max-width: 1450px) {
        .v-radio {
            margin-right: 8px;
        }
    }
}
::v-deep *:not(.v-radio) > .v-label {
    font-size: 14px !important;
    transform: translateY(-10px) scale(1) !important;
}
.radio-group {
    border: 1px solid #a8a8a8;
    border-radius: 5px;
    padding: 8px 10px;
    width: 100%;
}
</style>
